import Head from 'next/head'
import React from 'react'

export const HeightFix = () => (
  <Head>
    <style type="text/css">
      {`
        html {
          height: 100%;
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;
          touch-action: manipulation;
        }
        `}
    </style>
  </Head>
)
